<template>
    <div class="youtube-player">
        <div class="poster-container" @click="show">
            <div class="icon">
                <i class="fas fa-play"></i>
            </div>
            <b-img fluid-grow class="youtube-poster" :src="poster"></b-img>
        </div>
        <slot>
            <h4>{{title|tr}}</h4>
            <p>{{description|tr}}
            </p>
        </slot>

        <b-modal size="xxl" centered modal-class="modal-youtube" v-if="visible" v-model="visible" no-close-on-backdrop body-class="p-0" hide-footer>
            <iframe class="youtube-iframe" :width="videoWidth" :height="videoHeight" :src="videoIframeSrc" :title="videoTitle"
                    frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: `youtube-player`,
        props: {
            iframeSrc: { type: String, required: true },
            poster: { type: String, required: true },
            title: {type: String},
            disableAutoplay: {type: Boolean},
            description: {type: String}
        },
        data() {
            return {
                visible: false
            }
        },
        computed: {
            videoIframeSrc() {
                let iframeSrc = this.iframeSrc;
                if (!this.disableAutoplay) {
                    iframeSrc += `?autoplay=1`;
                }
                return iframeSrc;
            },
            videoTitle() {
                return getValueOrDefault(this.title, `YouTube Video Player`);
            },
            videoWidth() {
                if (window.innerWidth > 1300) {
                    return 1280;
                } else if (window.innerWidth > 1024) {
                    return 800;
                } else {
                    return 350;
                }
            },
            videoHeight() {
                if (window.innerWidth > 1300) {
                    return 720;
                } else if (window.innerWidth > 1024) {
                    return 450;
                } else {
                    return 197;
                }
            }
        },
        methods: {
            show() {
                this.visible = true;
            },
            hide() {
                this.visible = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
.poster-container {
    position: relative;
    margin-bottom: 10px;
    display: flex;
    align-content: center;
    justify-content: center;
    cursor: pointer;
    background-color: black;
    border-radius: 8px;
    overflow: hidden;

    .icon {
        position: absolute;
        left: calc(50% - 50px);
        top: calc(50% - 50px);
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        z-index: 1;
        font-size: 30pt;
        border-radius: 50%;
        background: rgba(#ff0000, 0.8);
        transition: 250ms;

        i {
            color: white;
        }
    }

    .youtube-poster {
        transition: 250ms;
    }

    &:hover {
        .icon {
            transform: scale(1.1);
            background: #ff0000;
        }

        .youtube-poster {
            opacity: 0.8;
        }
    }
}

.youtube-iframe {
    border-radius: 0;
}
</style>
